import * as actions from './actions';

export default (state = {
  isNameUnique: true,
}, action) => {
  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        companyId: action.companyId
      };
    case actions.INIT.END:
      return {
        ...state,
        origProject: action.origProject,
        project: action.project,
        isNameUnique: true,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        project: action.origProject
      };
    case actions.SET_COST_OF_ESTIMATION.END:
      return {
        ...state,
        project: {
          ...state.project,
          costOfEstimationUnit: action.costOfEstimationUnit,
        }
      };
    case actions.SET_NAME.BEGIN:
      return {
        ...state,
        project: {
          ...state.project,
          name: action.name,
        }
      };
    case actions.SET_NAME.END:
      return {
        ...state,
        isNameUnique: action.isNameUnique
      };
      case actions.CHANGE_ACTIVITY.BEGIN:
      return {
        ...state,
        project: {
          ...state.project,
          name: action.name,
        }
      };
    case actions.CHANGE_ACTIVITY.END:
      return {
        ...state,
        isNameUnique: action.isNameUnique
      };
    case actions.SAVE:
      return {
        ...state,
        origProject: action.project
      };
      case actions.SET_ESTIMATION_UNIT.BEGIN:
      return {
        ...state,
        project: {
          ...state.project,
          estimationUnit: action.estimationUnit,
        }
      };
      case actions.SET_ESTIMATION_UNIT.END:
      return {
        ...state,
        isCostOfEstUnitVisible: action.isCostOfEstUnitVisible
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/general/fieldset/reducer.js